export default {
      id: "common__command-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__command",
      toString: function () {
        return this.url;
      }
    }